import Vue from 'vue';
import Vuex from 'vuex';
import settingsStore from './modules/settings';
import sortingStore from './modules/sorting';
import aardStore from './modules/aard';
import accountmanagersStore from './modules/accountmanagers';
import locationsStore from './modules/locations';
import selectedStore from './modules/selected';
import countryStore from './modules/country';
import titleStore from './modules/titles';
import usersStore from './modules/users';
import contactMomentCategoryStore from './modules/contactMomentCategory';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        settingsStore: settingsStore,
        sortingStore: sortingStore,
        aardStore: aardStore,
        accountmanagersStore: accountmanagersStore,
        locationsStore: locationsStore,
        selectedStore: selectedStore,
        countryStore: countryStore,
        titleStore: titleStore,
        usersStore: usersStore,
        contactMomentCategoryStore: contactMomentCategoryStore,
    }
});